/**
 * "Cancelled by Alice on 13 Oct 2026 — “reason”": the record of a dropped
 * partner, shown on the cancelled assignment. Renders nothing for an assignment
 * that is not cancelled.
 */

import { Text } from '@mantine/core';

import { useActorNames } from '@/hooks/useActorNames';
import { isAssignmentCancelled, type BackofficeAssignment } from '@/types/np-assignments';
import { formatDueDate } from '@/utils';

export function CancelledNote({ assignment }: Readonly<{ assignment: BackofficeAssignment }>) {
  const nameFor = useActorNames();
  if (!isAssignmentCancelled(assignment)) {
    return null;
  }
  const who = assignment.cancelledByUserId ? nameFor(assignment.cancelledByUserId) : 'the system';
  const when = assignment.cancelledAt ? ` on ${formatDueDate(assignment.cancelledAt)}` : '';
  return (
    <Text size="xs" c="dimmed" data-testid={`cancelled-note-${assignment.id}`}>
      Cancelled by {who}
      {when}
      {assignment.cancelReason ? ` — “${assignment.cancelReason}”` : ''}. The assignment and its fee
      stay on the record.
    </Text>
  );
}
